import React from "react";
import styled from "styled-components";
import { Modal, Row, Col, Collapse, Divider } from "antd";
import { DateRangePicker } from "../../containers/ReportPanels/DatePickerCompare";
import { DateUtil, isFunction, ArrayUtil } from "../../util";
import { OButton } from "../button/OButton";
import { SimpleText } from "../text/OText";
import i18n from "../../i18n/index";
import { Metrics } from "../../theme";

class ExportDateRangeModal extends React.Component{
    state = {
    	visible:false
    };
    customDate = null;
    constructor(props){
    	super(props);
    	const { setRef, customDate } = props;
    	this.customDate = customDate.slice();
    	if(isFunction(setRef)){
    		setRef(this);
    	}
    }
    componentWillReceiveProps(props){
    	const { customDate } = props;
    	this.customDate = customDate.slice();
    	this.forceUpdate();
    }
    show = ()=>{
    	this.setState({visible:true});
    }
    hide = ()=>{
    	this.setState({visible:false});
    }
	internalOnSumbit = (range)=>{
		this.hide();
		const { onSubmit } = this.props;
		onSubmit(range);
	}
	toDateText(range){
		if(ArrayUtil.isAliveArray(range)){
			const format = "DD MMM YYYY";
			return `${range[0].format(format)} - ${range[1].format(format)}`;
		}
		return i18n.t("all_time");
	}
	onCustomDateChanged = (range)=>{
		this.customDate = range;
		this.forceUpdate();
	}
	render(){
		const { primaryDate, secondaryDate, title } = this.props;
    	const { visible } = this.state;
    	return <Modal
    		visible={visible}
			footer={null}
			onCancel={this.hide}
			title={title}>
			<React.Fragment>
				<ElementRow>
					<ButtonCal>
						<OButton style={{width:"100%"}} onClick={()=>this.internalOnSumbit(primaryDate)}>
							{i18n.t("primary")}
						</OButton>
						
					</ButtonCal>
					<DateCal>
						<SimpleText>
							{this.toDateText(primaryDate)}
						</SimpleText>
					</DateCal>
				</ElementRow>
				<ElementRow>
					<ButtonCal>
						<OButton style={{width:"100%"}} onClick={()=>this.internalOnSumbit(secondaryDate)}>
							{i18n.t("secondary")}
						</OButton>
					</ButtonCal>
					<DateCal>
						<SimpleText>
							{this.toDateText(secondaryDate)}
						</SimpleText>
					</DateCal>
				</ElementRow>
				<ElementRow>
					<ButtonCal>
						<OButton style={{width:"100%"}} onClick={()=>this.internalOnSumbit(this.customDate)}>
							{i18n.t("custom")}
						</OButton>
					</ButtonCal>
					<DateCal>
						<DateRangePicker value={this.customDate} onChange={this.onCustomDateChanged}/>
					</DateCal>
				</ElementRow>
			</React.Fragment>
    	</Modal>;
	}
}
const ButtonCal = styled(Col).attrs({
	span:6
})``;
const DateCal = styled(Col).attrs({
	span:18,
})`
	line-height:32px;
`;
const ElementRow = styled(Row).attrs({
	gutter:Metrics.button.mediumSpaceMargin
})`
	margin-bottom:6px;
`;

ExportDateRangeModal.defaultProps = {
	setRef:undefined,
	primaryDate: null,
	secondaryDate: null,
	customDate: DateUtil.getCurrentMonthDateRange(),
	title:i18n.t("pick_export_date"),
	onSubmit: (range)=>{console.log("dateRange: ",range);}
};
export default ExportDateRangeModal;


// WEBPACK FOOTER //
// ./src/components/modal/ExportDateRangeModal.js